import { render, staticRenderFns } from "./le-input-suffix.vue?vue&type=template&id=2ac42d34&scoped=true&"
import script from "./le-input-suffix.vue?vue&type=script&lang=js&"
export * from "./le-input-suffix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac42d34",
  null
  
)

export default component.exports